import { environment } from './../../environments/environment.prod';
import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr";


@Injectable({
  providedIn: 'root'
})
export class DownloadUserTemplateHubService {

  private hubConnection: signalR.HubConnection;

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(environment.apiUrl + 'UserTemplates/DownloadTemplates')

    .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  public addTransferChartDataListener = () => {
    this.hubConnection.on('ReceiveMessage', (data) => {
      console.log("Received data:");
      console.log(data);
    });
  }

  constructor() { }
}
